import { request, threeRe, jsonp } from "./network.js";


function selOwner(obj) {
	return request({
		url: "/app/h5/selOwner",
		method: 'GET',
		params: {
			housingId: obj.housingId,
			roomNumber: obj.roomNumber,
		}
	})
}
function confirmOrder(obj) {//下单
	return request({
		url: "/app/h5/confirmOrder",
		// method:'GET',
		headers: {
				"Content-type": "application/json",
				// "Content-Type": "x-www-form-urlencod"
			},
		data: {
			housingId: obj.housingId,//小区id
			roomId:obj.roomId,//房屋id
			payStatus: '0',//支付状态，0默认未支付
			payMode: '2',//2是线下支付
			receivableMoney: obj.receivableMoney,//应收金额
			discountsMoney: "0.00",//折扣金额
			paymentItemId: "",//支付方式名称
			dealMode: obj.dealMode, //'交易方式: 1=微信,2=POS机,3=现金,4=转账,5=其它,6=线下微信,7=预存款抵扣，8=线下支付宝，9=线下云闪付',
			realName: obj.realName, //业主姓名
			digest: '线下h5支付', 
		}
	})
}
function pay(obj) {//拉起支付
	return request({
		url: "/app/h5/pay",
		// method:'GET',
		headers: {
				"Content-type": "application/json",
				// "Content-Type": "x-www-form-urlencod"
			},
		data: {
			mId: obj.mId,
			transNo: obj.transNo,
			amt: obj.amt,
			payType: obj.payType,
		}
	})
}
function paymentShow(obj) {
	return request({
		url: "/paymentShow",
		params: {
			store_id: obj.store_id,
			template_id: obj.template_id,
		}
	})
}
function listPayment(obj) {
	return request({
		url: "/listPayment",
		params: {
			content: obj.content,
			template_id: obj.template_id,
		}
	})
}
function addMemberPayment(obj) {
	return request({
		url: "/addMemberPayment",
		params: {
			store_id: obj.store_id,
			template_id: obj.template_id,
			project_id: obj.project_id,
			content: obj.content
		}
	})
}

function addListPayment(obj) {
	return request({
		url: "/addListPayment",
		params: {
			store_id: obj.store_id,
			template_id: obj.template_id,
			project_id: obj.project_id,
			content: obj.content,
			remark: obj.remark,
			info_id: obj.info_id
		}
	})
}

function addSelectionPayment(obj) {
	return request({
		url: "/addSelectionPayment",
		params: {
			store_id: obj.store_id,
			template_id: obj.template_id,
			project_id: obj.project_id,
			content_first: obj.content_first,
			content_second: obj.content_second,
			content_third: obj.content_third,
			content_forth: obj.content_forth,
			content_money: obj.content_money,
		}
	})
}

function wxPayment(obj) {
	return request({
		url: "/wxPayment",
		params: {
			storeid: obj.storeid,
			order_no: obj.order_no,
			payType: obj.payType,
			money: obj.money,
		}
	})
}

function selectionOrder(obj) {
	return request({
		url: "/selectionOrder",
		params: {
			content_forth: obj.content_forth,
			template_id: obj.template_id,
			store_id: obj.store_id,
		}
	})
}
function judgeTemplateStatus(obj) {
	return request({
		url: "/judgeTemplateStatus",
		params: {
			template_id: obj.template_id,
		}
	})
}
function onlyOrderShow(obj) {
	return request({
		url: "/onlyOrderShow",
		params: {
			template_id: obj.template_id,
		}
	})
}

function selectPayment(obj) {
	return request({
		url: "/selectPayment",
		params: {
			template_id: obj.template_id,
		}
	})
}
function customPayment(obj) {
	return request({
		url: "/customPayment",
		params: {
			template_id: obj.template_id,
		}
	})
}
function listPaymentIndex(obj) {
	return request({
		url: "/listPaymentIndex",
		params: {
			// store_id: obj.store_id,
			template_id: obj.template_id,
		}
	})
}

function paymentExcelInfo(obj) {
	return request({
		url: "/customInfo",
		params: {
			phone: obj.student_code,
			name: obj.studyName,
			template_id: obj.template_id,
		}
	})
}

function customOrder(obj) {
	return request({
		url: "/customOrder",
		params: {
			phone: obj.student_code,
			name: obj.studyName,
			template_id: obj.template_id,
		}
	})
}

function addCustomPayment(obj) {
	return request({
		url: "/addCustomPayment",
		params: {
			template_id: obj.template_id,
			name: obj.content_first,
			phone: obj.content_forth,
			project_id: obj.project_id,
			store_id: obj.store_id,
			payment_info: obj.payment_info,
			custom_info_id: obj.custom_info_id,
			payment_event: obj.content_second,
			content_money: obj.content_money,
			// content_third: obj.content_third,
		}
	})
}




// function imgUrl() { //图片上传路径

// 	return 'https://xmappoint.yinheyun.com.cn/uploads/' //线上
// }


//对字符串进行加密   
// function compileStr(code) {
// 	var c = String.fromCharCode(code.charCodeAt(0) + code.length);
// 	for (var i = 1; i < code.length; i++) {
// 		c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
// 	}
// 	return escape(c);
// }

//字符串进行解密   
// function uncompileStr(code) {
// 	code = unescape(code);
// 	var c = String.fromCharCode(code.charCodeAt(0) - code.length);
// 	for (var i = 1; i < code.length; i++) {
// 		c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
// 	}
// 	return c;
// }
//获取url参数
// function getUrl(name) {
// 	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
// 	var r = window.location.search.substr(1).match(reg);
// 	if (r != null) return decodeURI(r[2]);
// 	return null;
// }
//全局定时任务
// function orderTime(obj){
// 	const timer = setInterval( function get(){
// 		clearInterval(timer);
// 		alert('已经十五分钟了');
// 	}, obj);
// }





export default {
	pay,
	confirmOrder,
	addCustomPayment,
	customOrder,
	customPayment,
	paymentExcelInfo,
	addListPayment,
	selectionOrder,
	addSelectionPayment,
	paymentShow,
	addMemberPayment,
	wxPayment,
	judgeTemplateStatus,
	onlyOrderShow,
	listPayment,
	listPaymentIndex,
	selectPayment,
	selOwner
}
